var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.props.subcomponent,{ref:_vm.props.id,tag:"component",attrs:{"id":_vm.props.id,"props":_vm.props.subcomponent_attributes},on:{"update":_vm.update}})}
var staticRenderFns = []

export { render, staticRenderFns }